import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { MaterialModule } from 'src/app/material.module';
import { ApiTitleComponent } from '../../common/api-title/api-title.component';
import { ApiUIResponseComponent } from '../api-ui-response/api-ui-response.component';
import { GlobalContants, Resource } from 'src/app/constants/global.contants';
import { environment } from 'src/environments/environment';
import { apiEndPoints } from 'src/app/constants/api-endpointsconstant';
import { SharedService } from 'src/app/services/shared.service';
import { UserService } from 'src/app/services/user.service';
import { HTTPMethod } from 'src/app/constants/enum';

export interface statusCode {
  key: string;
  value: string;
  required: boolean;
}

const Headers: statusCode[] = [
  {
    key: 'Content-Type',
    value: 'application/json',
    required: false,
  },
  {
    key: 'API-KEY',
    value: '{{API-KEY}}',
    required: true,
  },
  {
    key: 'USER-TOKEN',
    value: '{{USER-TOKEN}}',
    required: true,
  },
];
const QueryData: any = [
  {
    param: 'lat',
    value: '{{lat}}',
    required: true,
  },
  {
    param: 'lon',
    value: '{{lon}}',
    required: true,
  },
  {
    param: 'filter',
    value: '{{filter}} Filter value in json format e.g.',
    code: `{
      "unit_area" : "",
      "units_per_floor" : "",
      "is_furnished" : "",
      "central_ac" : "",
      "split_unit" : "",
      "total_units_in_contract" : "",
      "property_building" : "",
      "parking_available" : "",
      "property_other" : "",
      "total_floors" : "",
      "property_closed_retail_mall" : "",
      "property_multistory_building" : "",
      "property_others" : "",
      "property_open_retail" : "",
      "property_land" : "",
      "property_tower" : "",
      "property_factory" : "",
      "property_farm" : "",
      "property_vacation_house" : "",
      "is_compound_property_part" : "",
      "unit_exhibtion" : "",
      "unit_office" : "",
      "unit_shop" : "",
      "unit_finishing_finished" : "",
      "unit_finishing_unfinished" : "",
      "unit_finishing_structure" : "",
      "include_mezzanine" : "",
      "elevators" : "",
      "security_entries" : "",
      "total_floors_in_property" : "",
      "property_villa" : ""
    }`,
    required: false,
  },
];

@Component({
  selector: 'app-commercial-rental',
  standalone: true,
  imports: [
    CommonModule,
    MaterialModule,
    RouterModule,
    ApiTitleComponent,
    ApiUIResponseComponent,
  ],
  templateUrl: './commercial-rental.component.html',
  styleUrl: './commercial-rental.component.scss',
})
export class CommercialRentalComponent {
  HTTPMethod = HTTPMethod;
  displayedColumns: string[] = ['key', 'value', 'required'];
  QueryColumns: string[] = ['param', 'value', 'required'];
  dataSource = Headers;
  QueryDataSource = QueryData;
  api_ui: boolean = false;

  GlobalContants = GlobalContants;
  constructor(private sharedService: SharedService, 
    private userService: UserService, 
    private router: Router) {}

  ngOnInit() {
    let userInfo = this.sharedService.getStoreValue(GlobalContants.StoreKey.userInfo);
    this.userService.getAllUserResource(userInfo.user_id)
      .subscribe({
        next: (res: any) => {
          const matched = res.data.find((r: any) => r.resource_name === Resource.CommercialRental);
            if (!matched?.methods?.includes(HTTPMethod.GET)) {
             this.router.navigate(['/'])
            }
        },
        error: (err) => {
        }
      })
  }

  ngAfterViewInit() {}

  api_demo = `${environment.apiBaseUrl}${apiEndPoints.commercialRental}`;

  api_response = `{
    "status": 0,
    "message": "string",
    "data": {
      "property_uid": "string",
      "commercial_rental_midpoint": 0,
      "commercial_rental_lower_range": 0,
      "commercial_rental_higher_range": 0,
      "average_growth_rate": {},
      "street_data": [
        {
          "road_name": "string",
          "category": "string",
          "distance": 0,
          "road_width": 0
        }
      ]
    }
  }`;
}
